// extracted by mini-css-extract-plugin
module.exports = {"sideBySides":"SideBySides_sideBySides__HSWLZ","sideBySideItem":"SideBySides_sideBySideItem__MKfS0"};